<template>
  
    <el-dialog
      title=""
      :visible.sync="$store.state.groupObj.groupFalg"
      width="90%"
      :append-to-body="true"
      :close-on-click-modal="false"
      center>
        <div class="tabs-container ng-scope" v-if="$store.state.groupObj.groupFalg" style="padding-bottom:50px;margin-top:18px;">
          <el-form  :model="$store.state.groupObj.obj" ref="groupDetail"  label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <el-tabs >
              <el-tab-pane
                :label="langItem.name"
                v-for="(langItem, index) in $store.state.userInfo.language"
              >
              <div class="tab-content">
                <div>
                  <div class="form-group" v-if="$store.state.groupObj.objType==0">
                      <label class="col-sm-2 control-label">Others Title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div>          
                  <div class="form-group"  v-if="$store.state.groupObj.objType==0">
                      <label class="col-sm-2 control-label">Others Content</label>
                      <div class="col-sm-10">
                          <div>
                              <ckeditor :editor="editor"  @ready="onReady" v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).content" :config="editorConfig2" ></ckeditor>
                          </div>
                      </div>
                  </div>   


                  <div class="form-group"  v-if="$store.state.groupObj.objType==1">
                      <label class="col-sm-2 control-label">Group title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==14">
                      <label class="col-sm-2 control-label">Contact Person</label>
                      <div class="col-sm-10">
                          <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).contactPerson" show-word-limit :maxlength="100"></el-input>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==14">
                      <label class="col-sm-2 control-label">Phone</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="$store.state.groupObj.obj.phone" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==14">
                      <label class="col-sm-2 control-label">Email</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="$store.state.groupObj.obj.email" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 

                  <div class="form-group"  v-if="$store.state.groupObj.objType==2">
                      <label class="col-sm-2 control-label">Group name</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 

                  <div class="form-group"  v-if="$store.state.groupObj.objType==3">
                      <label class="col-sm-2 control-label">Organisation Name</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.name'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).name" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==3">
                      <label class="col-sm-2 control-label">Organisation Content</label>
                      <div class="col-sm-10">
                          <div>
                              <ckeditor :editor="editor"  @ready="onReady" v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).content" :config="editorConfig3" ></ckeditor>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==3">
                      <label class="col-sm-2 control-label">Organisation Image</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).image" show-word-limit :maxlength="1000"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==3">
                      <label class="col-sm-2 control-label">Alt Text</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).altText" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==3">
                      <label class="col-sm-2 control-label">Caption</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).caption" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group" v-if="$store.state.groupObj.objType==4">
                    <label class="col-sm-2 control-label">
                      Visual Type
                    </label>
                    <div class="col-sm-4">
                      <el-form-item 
                          prop="visualType"
                          :rules="{
                            required: true, message: $t('message.required'), trigger: 'change'
                          }"
                        >
                        <el-select  v-model="$store.state.groupObj.obj.visualType" @change="changeVisualType" clearable >
                            <el-option 
                            v-for="item in visualTypeObj"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group" v-if="$store.state.groupObj.objType==4">
                    <label class="col-sm-2 control-label">
                      File Type
                    </label>
                    <div class="col-sm-4">
                      <el-form-item 
                          prop="fileType"
                          :rules="{
                            required: true, message: $t('message.required'), trigger: 'change'
                          }"
                        >
                        <el-select  v-model="$store.state.groupObj.obj.fileType" @change="changeVisualType" clearable >
                            <el-option 
                            label="URL"
                            value="URL">
                            </el-option>
                            <el-option 
                            label="Upload"
                            value="Upload">
                            </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4&&$store.state.groupObj.obj.visualType=='video'&&$store.state.groupObj.obj.fileType=='URL'">
                      <label class="col-sm-2 control-label">Video Url</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.content'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input  v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).content" show-word-limit :maxlength="1000"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4&&$store.state.groupObj.obj.visualType=='image'&&$store.state.groupObj.obj.fileType=='Upload'">
                      <label class="col-sm-2 control-label">Image</label>
                      <div class="col-sm-3" >
                        <el-form-item 
                            :prop="'langMap.' + index + '.content'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'change'
                            }"
                          >
                          <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).content" style="display: none" show-word-limit :maxlength="1000"></el-input>
                          
                          <file-upload
                            :fileUploadUrl="fileUploadUrl"
                            :limit="5"
                            :type="'marker'"
                            :downloadImage="false"
                            :originalImage="false"
                            v-model="getObject($store.state.groupObj.obj.langMap, langItem.id).content"
                          >
                            <template v-slot:sizeError>
                              <div style="color:red">{{ $t("message.Size error!") }}</div>
                            </template>
                            <template v-slot:dimensionError>
                              <div style="color:red">{{ $t("message.Dimension Error!") }}</div>
                            </template>
                            <template v-slot:sizeHint>jpg/jpeg/png</template>
                          </file-upload>
                        </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4&&$store.state.groupObj.obj.visualType=='image'&&$store.state.groupObj.obj.fileType=='URL'">
                      <label class="col-sm-2 control-label">Image Url</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.content'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                         <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).content"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4&&($store.state.groupObj.obj.visualType=='file'||$store.state.groupObj.obj.visualType=='video')&&$store.state.groupObj.obj.fileType=='Upload'">
                      <label class="col-sm-2 control-label">Upload</label>
                      <div class="col-sm-3">
                        <el-upload
                          class=""
                          action="#"
                          :http-request="uploadFileEvent"
                          :auto-upload="true"
                          :show-file-list='false'
                          :data="index"
                        >
                          <el-button size="small">Select file (Max. 50Mb)</el-button>
                        </el-upload>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4&&($store.state.groupObj.obj.visualType=='file'||$store.state.groupObj.obj.visualType=='video')&&$store.state.groupObj.obj.fileType=='Upload'">
                      <label class="col-sm-2 control-label">File Url</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.content'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                         <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).content" disabled></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4&&$store.state.groupObj.obj.visualType=='file'&&$store.state.groupObj.obj.fileType=='URL'">
                      <label class="col-sm-2 control-label">File Url</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.content'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                         <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).content"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4">
                      <label class="col-sm-2 control-label">Caption</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).caption" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==4">
                      <label class="col-sm-2 control-label">Alt Text</label>
                      <div class="col-sm-10">
                          <div v-if="!$store.state.groupObj.altText">
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).altText" show-word-limit :maxlength="100"></el-input>
                          </div>
                          <el-form-item 
                              v-if="$store.state.groupObj.altText"
                              :prop="'langMap.' + index + '.altText'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).altText" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==5">
                      <label class="col-sm-2 control-label">Programme Name</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==6">
                      <label class="col-sm-2 control-label">Title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group" v-if="$store.state.groupObj.objType==6">
                    <label class="col-sm-2 control-label">
                      Start Date 
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-date-picker
                          v-model="$store.state.groupObj.obj.startDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                          placeholder="startDate">
                        </el-date-picker>
                      </div>
                    </div>
                    <label class="col-sm-2 control-label">
                      End Date 
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-date-picker
                          v-model="$store.state.groupObj.obj.endDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptionsEnd"
                          placeholder="endDate">
                        </el-date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-if="$store.state.groupObj.objType==6">
                    <label class="col-sm-2 control-label">
                      Start Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.startTime"
                          value-format="HH:mm"
                          :picker-options="{
                            format: 'HH:mm',
                          }"
                          placeholder="startTime">
                        </el-time-picker>
                      </div>
                    </div>
                    <label class="col-sm-2 control-label">
                      End Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.endTime"
                          value-format="HH:mm"
                          :picker-options="{
                            format: 'HH:mm',
                          }"
                          placeholder="endTime">
                        </el-time-picker>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-if="$store.state.groupObj.objType==6">
                    <label class="col-sm-2 control-label">
                      Repeat
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-select v-model="$store.state.groupObj.obj.repeat" clearable >
                            <el-option 
                            v-for="item in repeatObj"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==7">
                      <label class="col-sm-2 control-label">Title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==8">
                      <label class="col-sm-2 control-label">Title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==8">
                      <label class="col-sm-2 control-label">Sub Title</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).subTitle" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==8">
                      <label class="col-sm-2 control-label">Image</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).image" show-word-limit :maxlength="1000"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==8">
                      <label class="col-sm-2 control-label">Alt Text</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).altText" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==8">
                      <label class="col-sm-2 control-label">Description</label>
                      <div class="col-sm-10">
                          <div>
                              <ckeditor :editor="editor"  @ready="onReady" v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).description" :config="editorConfig3" ></ckeditor>
                          </div>
                      </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==9">
                      <label class="col-sm-2 control-label">Name</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.name'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).name" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==10">
                      <label class="col-sm-2 control-label">Name</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.name'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).name" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==10">
                      <label class="col-sm-2 control-label">Image</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).image" show-word-limit :maxlength="1000"></el-input>
                          </div>
                      </div>
                  </div>  
                  <div class="form-group"  v-if="$store.state.groupObj.objType==10">
                      <label class="col-sm-2 control-label">Alt Text</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).altText" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==10">
                      <label class="col-sm-2 control-label">Introduction</label>
                      <div class="col-sm-10">
                          <div>
                              <ckeditor :editor="editor"  @ready="onReady" v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).introduction" :config="editorConfig3" ></ckeditor>
                          </div>
                      </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==11||$store.state.groupObj.objType==15">
                      <label class="col-sm-2 control-label">Title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==11">
                    <label class="col-sm-2 control-label">
                      Type
                    </label>
                    <div class="col-sm-4">
                      <el-form-item 
                          prop="ccsType"
                          :rules="{
                            required: false, message: $t('message.required'), trigger: 'change'
                          }"
                        >
                        <el-select v-model="$store.state.groupObj.obj.ccsType" clearable v-bind:placeholder='$t("message.PleaseSelect")'>
                            <el-option value="Cast" label="Cast"></el-option>
                            <el-option value="Crew" label="Crew"></el-option>
                            <el-option value="Speaker" label="Speaker"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==12">
                      <label class="col-sm-2 control-label">Name</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.name'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).name" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==12">
                      <label class="col-sm-2 control-label">Image</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).image" show-word-limit :maxlength="1000"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==12">
                      <label class="col-sm-2 control-label">Alt Text</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).altText" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==12">
                      <label class="col-sm-2 control-label">Caption</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).caption" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==12">
                      <label class="col-sm-2 control-label">Description</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input type="textarea" :rows="2" v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).description" ></el-input>
                          </div>
                      </div>
                  </div>
                  
                  <div class="form-group"  v-if="$store.state.groupObj.objType==13">
                      <label class="col-sm-2 control-label">Talks / Forums Name</label>
                      <div class="col-sm-10">
                        <el-form-item 
                            :prop="'langMap.' + index + '.title'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'blur'
                            }"
                          >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group" v-if="$store.state.groupObj.objType==13">
                    <label class="col-sm-2 control-label">
                      Date 
                    </label>
                    <div class="col-sm-4">
                      <el-form-item 
                          prop="eventDate"
                          :rules="{
                            required: true, message: $t('message.required'), trigger: 'change'
                          }"
                        >
                        <el-date-picker
                          v-model="$store.state.groupObj.obj.eventDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="eventDate">
                        </el-date-picker>
                      </el-form-item >
                    </div>
                  </div>
                  <div class="form-group" v-if="$store.state.groupObj.objType==13">
                    <label class="col-sm-2 control-label">
                      Start Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.startTime"
                              value-format="HH:mm"
                              :picker-options="{
                                format: 'HH:mm',
                              }"
                          placeholder="startTime">
                        </el-time-picker>
                      </div>
                    </div>
                    <label class="col-sm-2 control-label">
                      End Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.endTime"
                              value-format="HH:mm"
                              :picker-options="{
                                format: 'HH:mm',
                              }"
                          placeholder="endTime">
                        </el-time-picker>
                      </div>
                    </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==13">
                      <label class="col-sm-2 control-label">Speaker / Guest</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).speaker" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==17">
                      <label class="col-sm-2 control-label">Title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==17">
                    <label class="col-sm-2 control-label">
                      Venue
                    </label>
                    <div class="col-sm-4">
                      <el-form-item 
                          prop="venue"
                          :rules="{
                            required: false, message: $t('message.required'), trigger: 'change'
                          }"
                        >
                        <el-select v-model="$store.state.groupObj.obj.venue" multiple clearable v-bind:placeholder='$t("message.PleaseSelect")'>
                            <el-option 
                            v-for="item in venueList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="form-group" v-if="$store.state.groupObj.objType==17">
                    <label class="col-sm-2 control-label">
                      Start Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.startTime"
                              value-format="HH:mm"
                              :picker-options="{
                                format: 'HH:mm',
                              }"
                          placeholder="startTime">
                        </el-time-picker>
                      </div>
                    </div>
                    <label class="col-sm-2 control-label">
                      End Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.endTime"
                              value-format="HH:mm"
                              :picker-options="{
                                format: 'HH:mm',
                              }"
                          placeholder="endTime">
                        </el-time-picker>
                      </div>
                    </div>
                  </div>
                  <div class="form-group"  v-if="$store.state.groupObj.objType==19">
                      <label class="col-sm-2 control-label">Show Title</label>
                      <div class="col-sm-10">
                          <el-form-item 
                              :prop="'langMap.' + index + '.title'"
                              :rules="{
                                required: true, message: $t('message.required'), trigger: 'blur'
                              }"
                            >
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).title" show-word-limit :maxlength="100"></el-input>
                          </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==19">
                      <label class="col-sm-2 control-label">Image</label>
                      <div class="col-sm-3" >
                        <el-form-item 
                            :prop="'langMap.' + index + '.image'"
                            :rules="{
                              required: true, message: $t('message.required'), trigger: 'change'
                            }"
                          >
                          <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).image" style="display: none" show-word-limit :maxlength="1000"></el-input>
                          <file-upload
                            :fileUploadUrl="fileUploadUrl"
                            :limit="5"
                            :type="'marker'"
                            :downloadImage="false"
                            :originalImage="false"
                            v-model="getObject($store.state.groupObj.obj.langMap, langItem.id).image"
                          >
                            <template v-slot:sizeError>
                              <div style="color:red">{{ $t("message.Size error!") }}</div>
                            </template>
                            <template v-slot:dimensionError>
                              <div style="color:red">{{ $t("message.Dimension Error!") }}</div>
                            </template>
                            <template v-slot:sizeHint>jpg/jpeg/png</template>
                          </file-upload>
                        </el-form-item>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==19">
                      <label class="col-sm-2 control-label">Caption</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).caption" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group"  v-if="$store.state.groupObj.objType==19">
                      <label class="col-sm-2 control-label">Alt Text</label>
                      <div class="col-sm-10">
                          <div>
                              <el-input v-model="getObject($store.state.groupObj.obj.langMap,langItem.id).altText" show-word-limit :maxlength="100"></el-input>
                          </div>
                      </div>
                  </div> 
                  <div class="form-group" v-if="$store.state.groupObj.objType==19">
                    <label class="col-sm-2 control-label">
                      Start Date 
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-date-picker
                          v-model="$store.state.groupObj.obj.date"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="date">
                        </el-date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-if="$store.state.groupObj.objType==19">
                    <label class="col-sm-2 control-label">
                      Start Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.startTime"
                          value-format="HH:mm"
                          :picker-options="{
                            format: 'HH:mm',
                          }"
                          placeholder="startTime">
                        </el-time-picker>
                      </div>
                    </div>
                    <label class="col-sm-2 control-label">
                      End Time
                    </label>
                    <div class="col-sm-4">
                      <div>
                        <el-time-picker
                          v-model="$store.state.groupObj.obj.endTime"
                          value-format="HH:mm"
                          :picker-options="{
                            format: 'HH:mm',
                          }"
                          placeholder="endTime">
                        </el-time-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group" v-if="$store.state.groupObj.objType==16">
                  <label class="col-sm-2 control-label">
                    Date 
                  </label>
                  <div class="col-sm-4">
                    <div>
                      <el-date-picker
                        v-model="$store.state.groupObj.obj.scheduleDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="scheduleDate">
                      </el-date-picker>
                    </div>
                  </div>
                </div> 
              </div>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.state.groupObj.groupFalg = false">Cancel</el-button>
        <el-button type="primary"  @click="checkEvent()">Confirm</el-button>
      </span>
    </el-dialog>
</template>
<script>
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import fileupload from "./fileuploadFile";
const upload = require('../../upload')
import config from "../../config";
export default {
  name: "groupDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'Heading', 'bold', 'italic','underline','Link', 'bulletedList', 'numberedList' ],
          // The configuration of the editor.
      },
      editorConfig2: {
        toolbar: [ 'Heading', 'bold', 'italic','underline','Link', 'bulletedList', 'numberedList','imageUpload' ],
          // The configuration of the editor.
         extraPlugins: [ upload.MyCustomUploadAdapterPlugin ]
      },
      editorConfig3: {
        toolbar: [ 'Heading', 'bold', 'italic','underline', 'bulletedList', 'numberedList' ],
          // The configuration of the editor.
      },
      venueObj:[],
      venueList:[],
      eventTypeObj:[],
      repeatObj:[],
      pickerOptions:{
        disabledDate:this.disabledDueDate
      },
      pickerOptionsEnd:{
        disabledDate:this.disabledDueDateEnd
      },
      visualTypeObj:[]
    };
  },
  components: {
    ClassicEditor,
    "file-upload": fileupload
  },
  methods: {
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    disabledDueDate(time){
        return time.getTime()>=new Date(this.$store.state.groupObj.obj.endDate).getTime();
    },
    disabledDueDateEnd(time){
        return time.getTime()<new Date(this.$store.state.groupObj.obj.startDate).getTime()-24*60*60*1000;
    },
    cancel: function() {
      this.$store.commit("setgroup", { string: "", boolean: false });
    },
    changeTabG: function(id) {
      $(".tabG" + id)
        .parent()
        .find("a")
        .click();
    },
    showTabG: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          // $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          // $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    checkEvent:function(){
        this.$refs["groupDetail"].validate((valid) => {
          if (valid) {
            this.addEvent();
          } else {
            this.$toastr.w(this.$i18n.t("message.fillRequired"));
            return false;
          }
        });
    },
    addEvent:function(){
      this.$store.state.groupObj.groupFalg = false;
      this.$store.state.groupObj.callback()
    },
    async getTypeList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.eventTypeList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if(data == this.TOKEN_EXPIRED){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "eventTypeObj", data.data.payload);
    },
    async getVenueList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.eventVenueList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if(data == this.TOKEN_EXPIRED){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "venueList", data.data.payload);
    },
    changeVisualType(){
      this.$store.state.groupObj.obj.langMap.forEach(item =>{
        item.content = ""
      })
    },
    async uploadFileEvent(params) {
      if(params.file.size>50*1024*1024){
        this.$message({
          message: "Max. 50MB",
          type: 'warning'
        });
        return;
      }
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.type = 'marker';
      obj.apiUrl = this.apiConfig.uploadImage;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if(data == 10401){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$store.state.groupObj.obj.langMap[params.data].content = data.data.payload.fileName;
    },
  },
  computed:{
      _obj(){
        return this.$store.state.groupObj.groupFalg
      }
  },
  watch: {
    _obj:function(){
      if(this.$store.state.groupObj.groupFalg){
        this.getVenueList();
      }
      setTimeout(function(){
        $(".tabG" + 1)
          .parent()
          .find("a")
          .click();

        $(".tabG" + 0)
          .parent()
          .find("a")
          .click();
      })
    }
  },
  mounted() {
      this.repeatObj=[{
        value: '1',
        label: 'Never'
      }, {
        value: '2',
        label: 'Every Day'
      }, {
        value: '3',
        label: 'Every Week'
      }, {
        value: '4',
        label: 'Every 2 Weeks'
      }, {
        value: '5',
        label: 'Every Month'
      }, {
        value: '6',
        label: 'Every Year'
      }]
      this.typeObj=[{
        label: 'Talk'
      }, {
        label: 'Forum'
      }]
      this.visualTypeObj=[{
        value: 'video',
        label: 'Video'
      }, {
        value: 'image',
        label: 'Image'
      }, {
        value: 'file',
        label: 'File'
      }]
  },
};
</script>
